// 참고 https://korinkorin.tistory.com/83?category=974678

import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import palette from "../../lib/styles/palette";
import Button from "../common/Button";

// 회원가입 or 로그인폼 보여줌.
const AuthFormBlock = styled.div`
  h3 {
    margin: 0;
    color: ${palette.gray[8]};
    margin-bottom: 1rem;
  }
`;

// button margin
const ButtonWithMarinTop = styled(Button)`
  margin-top: 1rem;
`;

// styled input
const StyledInput = styled.input`
  font-size: 1rem;
  border: none;
  border-bottom: 1px solid ${palette.gray[5]};
  padding-bottom: 0.5rem;
  outline: none;
  width: 100%;
  &:focus {
    color: $oc-teal-7;
    border-bottom: 1px solid ${palette.gray[7]};
  }
  /* Scss 에서 쓰는 요소가 서로 반복될 때 margin-top 을 줌 >>> input 과 input 사이에 margin-top 줌. */
  & + & {
    margin-top: 1rem;
  }
`;

// 폼 하단에 회원가입 링크 style
const Footer = styled.div`
  margin-top: 2rem;
  text-align: right;
  a {
    color: 1px solid ${palette.gray[6]};
    text-decoration: underline;
    &:hover {
      color: 1px solid ${palette.gray[9]};
    }
  }
`;

const AuthForm = ({ values, onChangeValues, onClickSubmit }) => {
  const text = "로그인";
  return (
    <AuthFormBlock>
      <h3>{text}</h3>
      <form onSubmit={onClickSubmit}>
        <StyledInput
          type="text"
          id="username"
          name="username"
          placeholder="유저아이디"
          value={values.username}
          onChange={onChangeValues}
        />
        <StyledInput
          type="password"
          id="password"
          name="password"
          placeholder="비밀번호"
          value={values.password}
          onChange={onChangeValues}
        />
        <ButtonWithMarinTop fullWidth>{text}</ButtonWithMarinTop>
      </form>
      <Footer>
        <Link to="/">처음으로</Link>
      </Footer>
    </AuthFormBlock>
  );
};

export default AuthForm;
